import _ from 'lodash';
import axios from 'axios';
import configService from '@/services/configService';
import utils from '@/helper/utils';

export default {
  async list({ type = 'user', query = {} } = {}) {
    const pickedQuery = _.pick(query, ['page', 'page_size', 'q', 'search', 'searchkey']);
    let url = `${configService.get('apiUrl')}/${type}`;
    if (!_.isEmpty(pickedQuery)) {
      url += `?${utils.toQueryStrings(pickedQuery)}`;
    }

    return axios
      .get(url, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async listStoreByUser() {

    const url = `${configService.get('apiUrl')}/store/user`;


    return axios
      .get(url, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async getOne({ type = 'user', mobile }) {
    return axios
      .get(`${configService.get('apiUrl')}/${type}/${mobile}`, {})
      .then(response => {
        return response.data;

      })
      .catch(e => {
        throw e;
      });
  },

  async postOne({ type = 'user', user } = {}) {
    return axios
      .post(`${configService.get('apiUrl')}/${type}`, user)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async patchOne({ type = 'user', mobile, newUser }) {
    return axios
      .patch(`${configService.get('apiUrl')}/${type}/${mobile}`, newUser)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async deleteOne({ type = 'user', mobile }) {
    return axios
      .delete(`${configService.get('apiUrl')}/${type}/${mobile}`)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async passwordChange({ type = 'user', mobile, passwordOld, passwordNew }) {
    return axios
      .patch(`${configService.get('apiUrl')}/${type}/password-change`, {
        mobile,
        passwordOld,
        passwordNew
      })
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async getOtp({ type = 'user', email }) {
    return axios
      .post(`${configService.get('apiUrl')}/${type}/forget-password/generate-otp`, {
        email
      })
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async passwordReset({ passwordNew, query = {} }) {
    return axios
      .patch(`${configService.get('apiUrl')}/user/password-reset/verify-otp`, passwordNew, { params: query })
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      }
      );
  },

  async getRoles() {
    return axios
      .get(`${configService.get('apiUrl')}/roles`, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async upload({ data } = {}) {
    return axios
      .post(`${configService.get('apiUrl')}/user/upload`, { data })
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async downloadReport() {
    return axios
      .get(`${configService.get('apiUrl')}/user/activeReport`, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async reportByDesignation() {
    return axios
      .get(`${configService.get('apiUrl')}/user/activeUserReportByDesignation`, {})
      .then(response => {
        return response.data;
      }
      )
      .catch(e => {
        throw e;
      }
      );

  },

  async reportByRoles() {
    return axios
      .get(`${configService.get('apiUrl')}/user/get-active-users-by-roles`, {})
      .then(response => {
        return response.data;
      }
      )
      .catch(e => {
        throw e;
      }
      );
  },
  async reportByRegion() {
    return axios
      .get(`${configService.get('apiUrl')}/user/get-active-users-by-region`, {})
      .then(response => {
        return response.data;
      }
      )
      .catch(e => {
        throw e;
      }
      );
  },

  async activeInactive() {
    return axios
      .get(`${configService.get('apiUrl')}/user/active-inactive-Report`, {})
      .then(response => {
        return response.data;
      }
      )
      .catch(e => {
        throw e;
      }
      );
  }
};
